<template>
  <footer class="footer-container">
    <div class="forms-footer">
      <div class="top-footer-container">
        <div class="top-links">
          <placeholder name="jss-top-links" :rendering="rendering" />
        </div>
        <div class="footer-logo">
          <sc-link :field="fields.racqWebsiteLink">
            <sc-image :media="fields.racqLogo" alt="RACQ Logo" />
          </sc-link>
        </div>
      </div>
      <div class="footer-copyright">{{ copyrightText }} {{ new Date().getFullYear() }}</div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import {
  Image as ScImage,
  Link as ScLink,
  ComponentFields,
  ComponentRendering,
  Placeholder,
  Field,
} from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';

const props = defineProps<{
  fields: ComponentFields;
  rendering: ComponentRendering;
}>();

const copyrightText = computed(() => (props.fields.copyrightText as Field).value);
</script>
